import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../service/auth.service';

@Component({
  selector: 'app-team-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './team-layout.component.html',
  styleUrl: './team-layout.component.css',
})
export class TeamLayoutComponent {
  constructor(private router: Router, private auth: AuthService) {}

  logout() {
    // Revoca la tessera lato server (best-effort), poi pulisci e vai al login.
    this.auth.logout().subscribe(() => {
      localStorage.removeItem('token');
      localStorage.removeItem('user_role');
      this.router.navigate(['/login']);
    });
  }
}
